export const EMAIL_REGEX = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;

/** Целое неотрицательное число: без знака, дробной части и разделителей */
export const NON_NEGATIVE_INTEGER_REGEX = /^\d+$/;
